import React, { FC } from 'react';
import { Trans } from '@lingui/macro';

import FaqSection from '@rover/components/src/FaqSection';
import LandingFaqList from '@rover/react-lib/src/pages/landing/components/LandingFaq/LandingFaqList';
import type { LocalityTypeEnum } from '@rover/rsdk/src/apiClient/latest/model/localityTypeEnum';
import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';
import { SeoLocationDescriptor } from '@rover/utilities/seo';

import { useApiSearchSeoLocationFaqsList } from '../utils/useSeoLocationHooks';

interface SeoLocationFaqListProps {
  seoLocationDescriptor: SeoLocationDescriptor;
  localityType: LocalityTypeEnum;
  internalServiceTypeName: string;
  locationName: string;
}

const SeoLocationFaqList: FC<SeoLocationFaqListProps> = ({
  seoLocationDescriptor,
  localityType,
  internalServiceTypeName,
  locationName,
}) => {
  const { data: faqs } = useApiSearchSeoLocationFaqsList(seoLocationDescriptor, localityType);

  if (!faqs || faqs.length === 0) return null;
  const brandDisplayName = getBrandDisplayName();

  return (
    <LandingFaqList faqs={faqs} mt="16x" mb="8x">
      <FaqSection.Header variant="heading" webProps={{ responsive: false }}>
        <Trans>
          FAQs for {internalServiceTypeName} - {locationName}
        </Trans>
      </FaqSection.Header>
      <FaqSection.Subheader>
        <Trans>Frequently asked questions about {brandDisplayName}</Trans>
      </FaqSection.Subheader>
    </LandingFaqList>
  );
};

export default SeoLocationFaqList;
